import { getRandomIntFromRange } from './getRandomIntFromRange';

/**
 * Use Reservoir Sampling to sample at most maxSize elements from given array
 *
 * @param array {T[]}: An array of elements to be sampled from
 * @param maxSize {number}: Max number of elements to be chosen
 * @returns {T[]} An array of element chosen randomly
 */
export const reservoirSample = <T>(array: T[], maxSize: number): T[] => {
  if (array.length <= maxSize) {
    return array;
  }
  const newValueList = array.slice(0, maxSize);
  for (let i = maxSize; i < array.length; i++) {
    const nextIndex = getRandomIntFromRange(0, i);
    if (nextIndex < maxSize) {
      newValueList[nextIndex] = array[i];
    }
  }
  return newValueList;
};
